const part = [
    {
        path: 'action-management-list',
        name: 'action-management-list',
        meta: {
            icon: 'md-people',
            title: '日志管理',
            notCache: true,
            access: ['S', 'I', 'I2'],
            items: [
            ]
        },
        component: () => import('@/view/system-management/action-management/action-list')
    }
];

export default part;
